import { render } from "./VolunteerInfo.vue?vue&type=template&id=377f23c9"
import script from "./VolunteerInfo.vue?vue&type=script&lang=js"
export * from "./VolunteerInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__